import React, { useState } from 'react';
import apiService from '../services/api.service';

const EmployeeCredentialsModal = ({ employee, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    employeeId: employee.employeeId || '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    if (!formData.employeeId.trim()) {
      setError('Kullanıcı adı boş olamaz.');
      return false;
    }

    if (!formData.password.trim()) {
      setError('Şifre boş olamaz.');
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Şifreler eşleşmiyor.');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    if (!validateForm()) return;

    setLoading(true);
    try {
      // Call the API to set/update employee credentials
      await apiService.setEmployeeCredentials(employee.id, {
        employeeId: formData.employeeId,
        password: formData.password
      });
      
      setSuccessMessage('Personel giriş bilgileri başarıyla kaydedildi.');
      setFormData(prev => ({
        ...prev,
        password: '',
        confirmPassword: ''
      }));
      
      if (onSuccess) {
        onSuccess({
          ...employee,
          employeeId: formData.employeeId
        });
      }
    } catch (err) {
      console.error('Error setting employee credentials:', err);
      setError('Giriş bilgileri kaydedilirken bir hata oluştu: ' + 
        (err.response?.data?.error || err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Personel Giriş Bilgileri</h3>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Kapat"
          >
            ×
          </button>
        </div>

        {error && <div className="error-message">{error}</div>}
        {successMessage && <div className="success-message">{successMessage}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="employeeIdInput">Personel Kullanıcı Adı *</label>
            <input
              type="text"
              id="employeeIdInput"
              name="employeeId"
              value={formData.employeeId}
              onChange={handleInputChange}
              required
              autoFocus
              placeholder="Personelin kullanıcı adı"
            />
            <small className="help-text">
              Bu, personelin giriş yaparken kullanacağı kullanıcı adıdır.
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="passwordInput">Şifre *</label>
            <input
              type="password"
              id="passwordInput"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              placeholder="Şifre"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPasswordInput">Şifre Tekrar *</label>
            <input
              type="password"
              id="confirmPasswordInput"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
              placeholder="Şifre tekrar"
            />
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              İptal
            </button>
            <button
              type="submit"
              className="save-button"
              disabled={loading}
            >
              {loading ? 'Kaydediliyor...' : employee.employeeId ? 'Güncelle' : 'Kaydet'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeeCredentialsModal;